<template>
    <el-dialog append-to-body :visible="isShow" @close="hide" :close-on-click-modal="false" :close-on-press-escape="false">
        <index-pop-template @hide="popFormHide" @save="add" :templateData="form" v-if="popFormIsShow"></index-pop-template>
        <el-form ref="form" :model="form" label-width="90px" size="mini">
            <el-form-item label="模版名称">
                <el-input size="mini"  v-model="form.templateName"></el-input>
            </el-form-item>
            <el-form-item label="模版编码">
                <el-input size="mini"  v-model="form.templateCode"></el-input>
            </el-form-item>
            <el-form-item label="系统简称">
                <el-input size="mini"  v-model="form.systemCode"></el-input>
            </el-form-item>
            <el-form-item label="纸张大小">
                <el-radio-group v-model="pageSize" size="medium">
                    <el-radio v-for="item in shortSize" :key="item.shortValue" :label="item.shortValue">{{item.shortName}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="纸张宽度" v-show="pageSize==='auto'">
                <el-col :span="10">
                    <el-input-number :controls-position="'right'" v-model="form.width" size="mini" :min="1" :max="500" label="宽度"></el-input-number>mm
                </el-col>
                <el-col class="text-center" :span="4">纸张高度 </el-col>
                <el-col :span="10">
                    <el-input-number :controls-position="'right'" v-model="form.height" size="mini" :min="1" :max="500" label="高度"></el-input-number>mm
                </el-col>
            </el-form-item>
            <el-form-item label="模版单位">
                <el-radio-group disabled v-model="form.unit" size="medium">
                    <el-radio label="mm">毫米</el-radio>
                    <el-radio label="cm">厘米</el-radio>
                    <el-radio label="px">点（无单位）</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.unit==='px'" label="像素毫米比">
                <el-input size="mini"  v-model="form.conversion" placeholder="模版名称/系统编码"></el-input>
            </el-form-item>
            <el-form-item label="模版">
                <el-button type="primary" @click="showPop" icon="el-icon-dish">点我编辑模版</el-button>
            </el-form-item>
            <el-form-item label="横向打印">
                <el-checkbox size="mini" true-label="2" v-model="form.intOrient">是否旋转90度（适用于标签等）</el-checkbox>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="hide">取 消</el-button>
            <el-button size="mini" type="primary" @click="save">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import IndexPopTemplate from "./IndexPopTemplate.vue";
    export default {
        props:{
            data:Object
        },
        components:{
            IndexPopTemplate
        },
        data() {
            return {
                form:{...this.data},
                popFormIsShow:false,
                isShow:true,
                pageSize:"auto",
                shortSize:[
                    {shortName:"100*180",shortValue:"100*180",width:100,height:180},
                    {shortName:"130*76",shortValue:"130*76",width:130,height:76},
                    {shortName:"90*76",shortValue:"90*76",width:90,height:76},
                    {shortName:"自定义",shortValue:"auto",width:100,height:180}
                ]
            }
        },
        watch:{
            "pageSize"(newValue){
                this.pageSizeChange(newValue)
            }
        },
        methods: {
            onSearch() {
                console.log('submit!');
            },
            hide(){
                this.$emit("hide");
            },
            save(){
                const errorTxt=this.check();
                if(errorTxt){
                    this.$alert(errorTxt);
                    return;
                }
                if(!this.form.content){
                    this.$alert("请先编辑模版！");
                    return;
                }
                this.$emit("save",this.form);
            },
            check(){
                const form=this.form;
                if(!form.templateName)return "模版名字必填！";
                if(!form.templateCode)return "模版编码必填！";
                if(!/^[a-zA-z_][-_a-zA-Z0-9]*$/.test(form.templateCode))return "模版编码必须是字母开头！并且只能由字母数字下划线和减号组成！";
                if(!form.systemCode)return "系统简称必填！";
                if(!this.pageSize)return "纸张大小必选！";
                if(this.pageSize==='auto'&&(!form.width||!form.height))return "纸张大小为自定义时，宽高必填！";
                if(!form.unit)return "模版内所用单位必填！";
                if(form.unit==="px"&&!form.conversion)return "当你用像素时候，你需要手动指定比例，因为像素和点阵一样，并不是真实固定长度！";
                return null
            },
            showPop(){
                const errorTxt=this.check();
                if(errorTxt){
                    this.$alert(errorTxt);
                    return;
                }
                this.popFormIsShow=true
            },
            popFormHide(){
                this.popFormIsShow=false
            },
            reset(data){
                for(let key in data){
                    if(data.hasOwnProperty(key)){
                        data[key]="";
                    }
                }
            },
            pageSizeChange(value){
                const pageSize=this.getPageSizeByShort(value);
                if(pageSize&&value!=="auto"){
                    this.form.width=pageSize.width;
                    this.form.height=pageSize.height
                }else {
                    const [width,height]=value.split("\*");
                    if(width){
                        this.form.width=width
                    }
                    if(height){
                        this.form.height=height
                    }
                }
                this.form.unit="px";
            },
            add(str){
                this.form.content=str
            },
            getPageSizeByShort(shortName){
                return {
                    "a4":{
                        width:100,
                        height:100
                    },
                    "auto":{
                        width:0,
                        height:0
                    }
                }[shortName||"auto"]
            }
        },
        mounted(){
            let pageSize=(this.form.width/10)+"*"+(this.form.height/10);
            this.pageSizeChange(pageSize);
            for(let i=0;i<this.shortSize.length;i++){
                if(this.shortSize[i].shortValue===pageSize){
                    this.pageSize=pageSize;
                    return
                }
            }
            this.pageSize="auto"
        }
    }
</script>
<style scoped>
    .text-center{text-align: center}
    .text-right{text-align: right}
</style>
